export default "__VITE_ASSET__BWWQd03G__"